<template>
  <div class="l_next_android">
    <div class="container">
      <div class="content">
        <p>
          いつも香の川製麺公式アプリをお使い頂き、ありがとうございます。<br />
          <br />
          香の川製麺公式アプリでは<span class="strong-red">11月中旬</span
          >に、次回のアップデートを予定しております。<br />
          次回アップデートでは、システムの都合上、<span class="strong-red"
            >継続使用を行うためには、最新版アプリ（3.0.0ver）以上へのアップデートが必要となります。</span
          ><br />
          <br />
          Androidで<span class="strong-red"
            >GooglePlayにてサポート対象外となった端末をお持ちのお客様は、香の川製麺公式アプリがお使いいただけなくなっております。</span
          ><br />
          <br />
          <span class="gray"
            >※サポート対象外となるお客様は、現時点で「香の川製麺公式アプリ
            version2.2.0」以上へのアップデートができなくなっております。<br />
            ※現在お使いの香の川製麺公式アプリのバージョン情報は、以下よりご確認ください。<br />
            <br />
            1）トップページ右上の「三」を押す。<br />
            2）表示されたページの1番下に表示される「Version
            x.x.x」が、現在お客様がお使いのアプリバージョンです。</span
          ><br />
          <br />
          サポート対象外となった端末をお使いになっていたお客様で、「アプリ会員ID」と「パスワード」をお控えの場合は、今後機種変更された場合にも「香の川製麺公式アプリ」を引き続きご利用いただけます。<br />
          <br />
          利用可能な端末で再度「香の川製麺公式アプリ」をインストールいただき、お控えいただいている「アプリ会員ID」と「パスワード」を入力してお使いください。<br />
          <br />
          有効期限内であれば、アップデート前まで貯められたスタンプやクーポンをご利用いただくことができます。<br />
          <br /><span class="gray"
            >※「アプリ会員ID」と「パスワード」は以下よりご確認下さい。<br />
            <br />
            1）トップページ右上の「三」を押す。<br />
            2）表示されたページの「機種変更の手続きについて」を押す。<br />
            3）「アプリ会員ID」と「パスワード」が表示されます。<br
          /></span>
          <br />
          お客様にはご迷惑をおかけしますが、ご理解のほど何卒よろしくお願い致します。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { FactoryTrack } from '../constant/firebase.js'
import { mapActions } from 'vuex'
import DateFormatter from '../utils/DateFormatter.js'

export default {
  name: 'FAQForAndroid',

  data: function() {
    return {
      userId: '',
      password: ''
    }
  },
  created() {
    document.title = '次回アップデートについて'
    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        this.userId = json.user_id
        window.receivedToken = null
      }
      // クーポン一覧と同じなので一旦apiTypeを3に設定する
      this.actionRequestToken({
        apiType: '3',
        acc_time: accTime
      })
    } catch (e) {
      console.log(e)
    }
    try {
      window.receivedPassword = payload => {
        this.password = payload
        window.receivedPassword = null
      }
      this.actionRequestPassword()
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Native', ['actionRequestToken', 'actionRequestPassword']),
    tapInquiry: function() {
      this.trackEvent(FactoryTrack.createFAQNextAndroid())
    }
  }
}
</script>

<style lang="scss" scoped>
.l_next_android {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;
}

.l_next_android h3,
.l_next_android h4 {
  color: #602209;
}

.l_next_android h4 {
  margin: 10px 0px;
}

.l_next_android .l_button__external {
  width: 250px;
  margin: 20px auto 0;
}

.l_next_android .content {
  background-color: #ffffff;
  text-align: left;
  padding: 20px;
}

.l_next_android .content hr {
  margin-top: 10px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 1px solid #efb90f;
}

.l_next_android .content img {
  margin-top: 20px;
  margin-bottom: 10px;
  max-width: 100%;
}

.l_next_android span.strong {
  font-weight: bold;

  &.red {
    color: #cc0000;
  }
}

img {
  max-width: 80%;
  width: 188px;
  display: block;
  border: 1px solid #dedede;
  margin: 0 auto;
}

.gray {
  color: rgb(102, 102, 102);
}

.strong-red {
  font-weight: bold;
  color: #e03535;
}
</style>
